// ----------------------------------------------------------------------------
// Component: Footer
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import "snippets/newsletter-form/newsletter-form";
import "snippets/icon/icon";
import "snippets/menu/menu";
import "sections/newsletter/newsletter";

// Styles
import "./_footer.scss";

// Handle country picker
window.onload = () => {
    const pickerWrapper = document.getElementById("country-wrapper");
    const picker = document.getElementById("country-picker");
    const currentHostname = document.location.hostname;
    const currentUrl = document.location.href;
    const isFrenchCa = document.location.pathname.startsWith("/fr");

    function setFlag(country) {
        let flagImgUrl = "";

        switch (country) {
            case "US":
                flagImgUrl =
                    "https://cdn.shopify.com/s/files/1/0568/3943/8384/files/USA.svg";
                break;
            case "AU":
                flagImgUrl =
                    "https://cdn.shopify.com/s/files/1/0568/3943/8384/files/AUS.svg";
                break;
            case "UK":
                flagImgUrl =
                    "https://cdn.shopify.com/s/files/1/0568/3943/8384/files/ENG.svg";
                break;
            case "CA-EN":
            case "CA-FR":
                flagImgUrl =
                    "https://cdn.shopify.com/s/files/1/0568/3943/8384/files/CAN.svg";
                break;
        }

        pickerWrapper.style.backgroundImage = `url(${flagImgUrl})`;
    }

    // Set initial picker values
    if (currentHostname === "us.dollarshaveclub.com") {
        picker.value = "US";
        setFlag("US");
    } else if (currentHostname === "au.dollarshaveclub.com") {
        picker.value = "AU";
        setFlag("AU");
    } else if (currentHostname === "uk.dollarshaveclub.com") {
        picker.value = "UK";
        setFlag("UK");
    } else if (currentHostname === "ca.dollarshaveclub.com" && isFrenchCa) {
        picker.value = "CA-FR";
        setFlag("CA-FR");
    } else if (currentHostname === "ca.dollarshaveclub.com") {
        picker.value = "CA-EN";
        setFlag("CA-EN");
    }

    const pickerEvents = ["click", "keydown"];
    for (event of pickerEvents) {
        picker.addEventListener(event, () => {
            picker.addEventListener("change", () => {
                let redirectToShopHref = "";
                switch (picker.value) {
                    case "US":
                        setFlag("US");
                        redirectToShopHref = "https://us.dollarshaveclub.com";
                        break;
                    case "AU":
                        setFlag("AU");
                        redirectToShopHref = "https://au.dollarshaveclub.com";
                        break;
                    case "UK":
                        setFlag("UK");
                        redirectToShopHref = "https://uk.dollarshaveclub.com";
                        break;
                    case "CA-EN":
                        setFlag("CA-EN");
                        redirectToShopHref = "https://ca.dollarshaveclub.com";
                        break;
                    case "CA-FR":
                        setFlag("CA-FR");
                        redirectToShopHref =
                            "https://ca.dollarshaveclub.com/fr";
                        break;
                }

                if (currentUrl.includes(redirectToShopHref) && isFrenchCa) {
                    window.location.href = redirectToShopHref;
                } else if (!currentUrl.includes(redirectToShopHref)) {
                    window.location.href = redirectToShopHref;
                }
            });
        });
    }
};
